import React from 'react';
import styles from './OperationalBanner.module.css';

const OperationalBanner = () => (
  <div className={styles.banner}>
    Operational view — clinical records remain owned by the treating doctor.
  </div>
);

export default OperationalBanner;
